import {
  Grid,
  Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer,
  TableHead, TablePagination, TableRow, Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { useEffect } from "react";
import OperationReportService from "../../../Services/Reports/OperationReportService";
import { getDate } from "../../Utils/Common";
import Snackbar from '../../Snacbar'
import HashLoader from "react-spinners/HashLoader";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
function BillWiseReport() {
  const mystyle = {
    border: " 1px solid black",fontFamily: 'Times New Roman',
    width: "12rem",
  };
  const mystyle1 = {
    fontWeight: "bolder",fontFamily: 'Times New Roman',
    color: "#0b64c5",
  };
  ///
  const [loading, setloading] = useState(false)
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [showProcs, setshowProcs] = useState(false)
  const [exportNon_BillExcelProcs, setexportNon_BillExcelProcs] = useState(false)
  const [exportBillExcelProcs, setexportBillExcelProcs] = useState(false)
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [details4, setdetails4] = useState([]);
  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [FilteredDetails2, setFilteredDetails2] = useState([]);
  const [BillWiseValues, setBillWiseValues] = useState({
    from: getDate(),
    to: getDate(),
    branch: 'ALL',
    cust: 'ALL',
  });
  const fromhandlechange = (e) => {
    setBillWiseValues({ ...BillWiseValues, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setBillWiseValues({ ...BillWiseValues, to: e.target.value })
  };
  const branchhandlechange = (e) => {
    setBillWiseValues({ ...BillWiseValues, branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const custhandlechange = (e) => {
    setBillWiseValues({ ...BillWiseValues, cust: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  //error message
  const handleClose = () => {
    setOpen(false)
  }
  ///
  const getfunctions = () => {
    OperationReportService.selectBranchDetails().then(res => {
      setdetails1(res.data);
    })
    OperationReportService.getCustomerBasedCustomerType('Importer').then(res => {
      setdetails2(res.data);
    })
  }
  //
  const getnonbillreport = () => {
    var imp_iec_no, cus = '';
    if (BillWiseValues.cust === 'ALL') {
      imp_iec_no = -1;
    } else {
      imp_iec_no = BillWiseValues.cust;
    }
    if (BillWiseValues.branch === 'ALL') {
      cus = -1
    } else {
      cus = BillWiseValues.branch;
    }
    let details = { fromDate: BillWiseValues.from, toDate: BillWiseValues.to, employeeId: -1, importer_iec_no: imp_iec_no, regionalId: cus, flag: 1 }
    OperationReportService.getBillAndNonBillReport(details).then(res => {
      const data = res.data;
      const details = data.map((item) => item)
      if (details[0] === [] || !details[0]) {
        setMessage('No Record Found');
        setseverit('warning')
        setOpen(true)
        setshowProcs(false)
        setloading(false)
      } else {
        setdetails3(res.data);
        setFilteredDetails(res.data);
        setshowProcs(false)
        setloading(false)
      }
    })
  }
  const getbillreport = () => {
    var imp_iec_no, cus = '';
    if (BillWiseValues.cust === 'ALL') {
      imp_iec_no = -1;
    } else {
      imp_iec_no = BillWiseValues.cust;
    }
    if (BillWiseValues.branch === 'ALL') {
      cus = -1
    } else {
      cus = BillWiseValues.branch;
    }
    let details = { fromDate: BillWiseValues.from, toDate: BillWiseValues.to, employeeId: -1, importer_iec_no: imp_iec_no, regionalId: cus, flag: 2 }
    OperationReportService.getBillAndNonBillReport(details).then(res => {
      const data = res.data;
      const details = data.map((item) => item)
      if (details[0] === [] || !details[0]) {
        setMessage('No Record Found');
        setseverit('warning')
        setOpen(true)
        setshowProcs(false)
        setloading(false)
      } else {
        setdetails4(res.data);
        setFilteredDetails2(res.data);
        setshowProcs(false)
        setloading(false)
      }
    })
  }
  const ExportNonBillingClick = () => {
    setexportNon_BillExcelProcs(true)
    if (!details3[0]) {
      setMessage('No Record Found')
      setseverit('warning')
      setOpen(true)
      setexportNon_BillExcelProcs(false)
    } else {
      var tableContent, contenall = '';
      for (let i = 0; i < details3.length; i++) {
        if (details3[i].operationType !== '') {
          tableContent = details3[i].operationType + "!"
        } else {
          tableContent += '   !'
        }
        if (details3[i].consignmentNumber !== '') {
          tableContent += details3[i].consignmentNumber + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details3[i].jobDate !== '') {
          tableContent += details3[i].jobDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].beNo !== '') {
          tableContent += details3[i].beNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].beDate !== '') {
          tableContent += details3[i].beDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceNumber !== '') {
          tableContent += details3[i].invoiceNumber + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceDate !== '') {
          tableContent += details3[i].invoiceDate + "#"
        } else {
          tableContent += '  #';
        }
        contenall += tableContent;
      }
      // console.log('contenall => '+JSON.stringify(contenall))
      let details = {
        headerName: "3,0,NON BILLING REPORT", headerDetails: "1,1,FROM DATE : " + BillWiseValues.from + "/4,1,TO DATE : " + BillWiseValues.to,
        tableHeader: "0,3,Sl.No/1,3,Job Type/2,3,Job No/3,3,Job Date/4,3,Be No/5,3,Be Date/6,3,Importer_Exporter Name/7,3,Forwarder Name",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "NonBill", totalNumberOfColumn: 8, tableContent: contenall.substring(0, contenall.length - 1),
      }
      OperationReportService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    }
    setexportNon_BillExcelProcs(false)
  }
  const ExportBillingClick = () => {
    setexportBillExcelProcs(true)
    if (!details4[0]) {
      setMessage('No Record Found')
      setseverit('warning')
      setOpen(true)
      setexportBillExcelProcs(false)
    } else {
      var tableContent, contenall = '';
      for (let i = 0; i < details4.length; i++) {
        if (details4[i].operationType !== '') {
          tableContent = details4[i].operationType + "!"
        } else {
          tableContent += '   !'
        }
        if (details4[i].consignmentNumber !== '') {
          tableContent += details4[i].consignmentNumber + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details4[i].jobDate !== '') {
          tableContent += details4[i].jobDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details4[i].beNo !== '') {
          tableContent += details4[i].beNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details4[i].beDate !== '') {
          tableContent += details4[i].beDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details4[i].invoiceNumber !== '') {
          tableContent += details4[i].invoiceNumber + "!"
        } else {
          tableContent += '  !';
        }
        if (details4[i].invoiceDate !== '') {
          tableContent += details4[i].invoiceDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details4[i].importer_name !== '') {
          tableContent += details4[i].importer_name + "#"
        } else {
          tableContent += '  #';
        }
        contenall += tableContent;
      }
      // console.log('contenall => '+JSON.stringify(contenall))
      let details = {
        headerName: "3,0,BILLING REPORT", headerDetails: "1,1,FROM DATE : " + BillWiseValues.from + "/4,1,TO DATE : " + BillWiseValues.to,
        tableHeader: "0,3,Sl.No/1,3,Job Type/2,3,Job No/3,3,Job Date/4,3,Be No/5,3,Be Date/6,3,Invoice No/7,3,Invoice Date/8,3,Party Name",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "Bill", totalNumberOfColumn: 9, tableContent: contenall.substring(0, contenall.length - 1),
      }
      OperationReportService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");
        setexportBillExcelProcs(false)
      })
    }
  }
  const showBtnClick = () => {
    setshowProcs(true)
    setloading(true)
    setPage(0)
    setPage2(0)
    getnonbillreport();
    getbillreport();
  }
  //
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getfunctions();
  }, []);

  //tabel search
  const jobNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobNoOnchange(e.target.value) }} />
  }
  const impExpNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { impExpnOnchange(e.target.value) }} />
  }
  const forwarderSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { frwrdrOnchange(e.target.value) }} />
  }
  const jobNo2Srch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobNo2Onchange(e.target.value) }} />
  }
  const invcNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { invcNoOnchange(e.target.value) }} />
  }
  const partNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { partyNmOnchange(e.target.value) }} />
  }
  //onchange
  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.regionalName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const impExpnOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.regionalName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const frwrdrOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.regionalName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const jobNo2Onchange = (searchedVal) => {
    const filteredvalue = details4.filter((trns) => {
      return trns.regionalName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails2(details4)
    } else {
      setFilteredDetails2(filteredvalue)
    }
  }
  const invcNoOnchange = (searchedVal) => {
    const filteredvalue = details4.filter((trns) => {
      return trns.regionalName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails2(details4)
    } else {
      setFilteredDetails2(filteredvalue)
    }
  }
  const partyNmOnchange = (searchedVal) => {
    const filteredvalue = details4.filter((trns) => {
      return trns.regionalName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails2(details4)
    } else {
      setFilteredDetails2(filteredvalue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  //dailogbox 2

  const [page2, setPage2] = React.useState(0);
  const [rowsPerPage2, setRowsPerPage2] = React.useState(10);

  const handleChangePage2 = (event, newPage) => {
    setPage2(newPage);
  }
  const handleChangeRowsPerPage2 = (event) => {
    setRowsPerPage2(parseInt(event.target.value, 10));
    setPage2(0);
  }
  return (
    <div>
      <Home />
      <div style={{ paddingLeft: '80px' }}>
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}><center>BILLING AND NON-BILLING REPORT</center></div>
            <Row>
              <Col><center>
                <label style={mystyle1}>From Date</label>
                <Form.Control size="sm" type="date" style={mystyle} value={BillWiseValues.from} onChange={fromhandlechange} /></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>To Date</label>
                <Form.Control size="sm" type="date" style={mystyle} value={BillWiseValues.to} onChange={tohandlechange} /></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>Branch Name</label>
                <Form.Select size="sm" style={mystyle} value={BillWiseValues.branch} onChange={branchhandlechange}>
                  {details1.map(trns => (
                    <option value={trns.regionId}>{trns.regionalName}</option>
                  ))}
                </Form.Select></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>Customer</label>
                <Form.Select type="text" list="code" tyle={mystyle} size="sm" value={BillWiseValues.cust} onChange={custhandlechange}>
                  <option value={'ALL'}>ALL</option>
                  {details2.map(trns => (
                    <option value={trns.importer_iec_no}>{trns.importer_name}</option>
                  ))}
                </Form.Select></center>
              </Col>
            </Row>
            <br></br>
            <Row>
              <Col lg={3}></Col>
              <Col lg={6}>
                <Button variant="primary" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={showBtnClick}>{showProcs ? 'processing...' : 'Show'}
                </Button>
                &nbsp;
                <Button variant="success" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={ExportNonBillingClick}>{exportNon_BillExcelProcs ? 'processing...' : 'Export Non-Billing Excel'}
                </Button>
                &nbsp;
                <Button variant="success"style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={ExportBillingClick}>{exportBillExcelProcs ? 'processing...' : 'Export Billing Excel'}
                </Button>
              </Col>
              <Col lg={3}></Col>
            </Row>
            <br></br>
            <Grid container>
              <Grid xs={6}>
                <ItemPap>
                  <Typography color={"darkblue"} fontWeight={"bolder"} variant={"h6"}>
                    Non-Billing Job List
                  </Typography>
                  <TableContainer sx={{ height: 320 }} className="mt-1">
                    <Table stickyHeader className="table table-bordered">
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell>SlNo</StyledTableCell>
                          <StyledTableCell>JobType</StyledTableCell>
                          <StyledTableCell>JobNo{jobNoSrch()}</StyledTableCell>
                          <StyledTableCell>Be_Date</StyledTableCell>
                          <StyledTableCell>ImporterExporterName{impExpNmSrch()}</StyledTableCell>
                          <StyledTableCell>Forwarder{forwarderSrch()}</StyledTableCell>
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((trns, index) => (
                            <TableRow hover key={trns.serialNumber}>
                              <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                              <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.operationType}</StyledTableCell>
                              <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentNumber}</StyledTableCell>
                              <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.beDate}</StyledTableCell>
                              <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceNumber}</StyledTableCell>
                              <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceDate}</StyledTableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    showFirstButton
                    showLastButton
                    component='div'
                    count={FilteredDetails.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onChangeRowsPerpage={handleChangeRowsPerPage}
                  />
                </ItemPap>
              </Grid>
              <Grid xs={6}>
                <ItemPap>
                  <Typography color={"darkblue"} fontWeight={"bolder"} variant={"h6"}>
                    Billing Job List
                  </Typography>
                  <TableContainer sx={{ height: 350 }} className="mt-1">
                    <Table stickyHeader className="table table-bordered">
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell>SlNo</StyledTableCell>
                          <StyledTableCell>JobType</StyledTableCell>
                          <StyledTableCell>JobNo{jobNo2Srch()}</StyledTableCell>
                          <StyledTableCell>InvoiceNo{invcNoSrch()}</StyledTableCell>
                          <StyledTableCell>InvoiceDate</StyledTableCell>
                          <StyledTableCell>PartyName{partNmSrch()}</StyledTableCell>
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {FilteredDetails2.slice(page2 * rowsPerPage2, page2 * rowsPerPage2 + rowsPerPage2)
                          .map((trns, index) => (
                            <TableRow hover key={trns.serialNumber}>
                              <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                              <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.operationType}</StyledTableCell>
                              <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentNumber}</StyledTableCell>
                              <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceNumber}</StyledTableCell>
                              <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceDate}</StyledTableCell>
                              <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.importer_name}</StyledTableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    showFirstButton
                    showLastButton
                    component='div'
                    count={FilteredDetails2.length}
                    rowsPerPage={rowsPerPage2}
                    page={page2}
                    onPageChange={handleChangePage2}
                    onChangeRowsPerpage={handleChangeRowsPerPage2}
                  />
                </ItemPap>
              </Grid>
            </Grid>
          </ItemPap>}
      </div>
    </div >
  );
}

export default BillWiseReport;
